import axios from '@axios'

export default {
  async getUserApplications(context) {
    try {
      const response = await axios.get('/apps/all')
      if (response.status === 200) {
        if (response.data.success) {
          // console.log(response.data.data)
          context.commit('setUserApplications', response.data.data)
        }
      }
    } catch (error) {
      // console.log(error)
    }
  },
}
